export enum VerifyLoginStep {
	RequestCode = 1,
	ValidateCode = 2,
	ExceededAttempts = 3,
}

export const enum OtherChannelOptions {
	ForgotPassword = "forgot-password",
	HasCode = "has-code",
}
